<template>
  <div>
    <BaseHeadline
      icon="mdi-account-hard-hat"
      :showOnMobile="true"
      :breadcrumbs="breadcrumbsData"
      :showBreadcrumbsOnMobile="true"
    >
    </BaseHeadline>

    <DocumentsList :documents="documents" :loading="loading" @click="clickBtn">
    </DocumentsList>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import documentApi from "@/api/documentApi";
import { Breadcrumbs, ProjectObject } from "@/types/interface";
import { mapGetters } from "vuex";

import {
  DocumentObject,
  DocumentsBreadcrumbs,
} from "@/types/documentInterface";

import DocumentsList from "@/components/shared/documents/DocumentsList.vue";

export default Vue.extend({
  data() {
    return {
      loading: true,
      project: {} as ProjectObject,
      documents: new Array<DocumentObject>(),
      breadcrumbs: new Array<DocumentsBreadcrumbs>(),
    };
  },
  async created() {
    await this.fetchData();
  },

  watch: {
    $route() {
      this.fetchData();
    },
  },

  methods: {
    async fetchData() {
      this.loading = true;
      this.documents = [];

      if (this.$route.name === "ProjectHmsWithUuid") {
        await documentApi
          .getDocumentsUuid(this.$route.params.id, this.$route.params.uuid)
          .then((repsonse) => {
            this.documents = repsonse.documents;
            this.breadcrumbs = repsonse.breadCrumbs;
            this.loading = false;
            this.project = repsonse.project;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        await documentApi
          .getHmsDocuments(this.$route.params.id)
          .then((repsonse) => {
            this.documents = repsonse.documents;
            this.breadcrumbs = repsonse.breadCrumbs;
            this.loading = false;
            this.project = repsonse.project;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    clickBtn(document: DocumentObject) {
      if (!document.applicationType) {
        //Is folder
        this.$router.push({
          name: "ProjectHmsWithUuid",
          params: { uuid: document.uuid },
        });
      } else {
        documentApi.downloadDocument(document);
      }
    },
  },

  computed: {
    ...mapGetters({
      isTrysilhus: "shared/isTrysilhus",
    }),
    breadcrumbsData(): Array<Breadcrumbs> {
      if (this.breadcrumbs && this.project) {
        var data = this.breadcrumbs
          .filter((y) => y.id)
          .map((x) => {
            return {
              disabled: x.last,
              text: x.title,
              to: {
                name: "ProjectHmsWithUuid",
                params: { uuid: x.id },
              },
              exact: true,
            };
          }) as Array<Breadcrumbs>;

        //add project first in breadcrumb
        return [
          {
            disabled: false,
            text: this.project.name,
            to: {
              name: "Project",
              params: { id: this.$route.params.id },
            },
            exact: true,
          },
          ...data,
        ];
      }

      return [];
    },
  },

  components: {
    BaseHeadline,
    DocumentsList,
  },
});
</script>
